// extracted by mini-css-extract-plugin
module.exports = {"body":"container-queries_body__CCKOD","media-wrapper":"container-queries_media-wrapper__RYr7N"};